import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface HeroSectionProps {
  isExpired: boolean;
}
export function HeroSection({
  isExpired
}: HeroSectionProps) {
  const price = isExpired ? '$47.00' : '$6.36';
  return <section className="relative min-h-[70vh] flex items-center justify-center py-12 px-4 overflow-hidden" data-id="element-138">
      {/* Background Image with Overlay - Optimized for performance */}
      <div className="absolute inset-0 z-0" data-id="element-139">
        <img src="https://cdn.magicpatterns.com/uploads/ekokBKMv7XjfUeBFkHsnNL/Banner.jpg" alt="Meditación en la naturaleza con anillos dorados" className="w-full h-full object-cover object-center" fetchPriority="high" decoding="async" loading="eager" data-id="element-140" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/55 to-dark" data-id="element-141"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-142">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-body" data-id="element-143">
          El Protocolo de 30 Días Que Silencia el Ruido Mental y Te Devuelve el
          Control de Tu Vida
        </h1>

        <p className="text-[17px] text-body max-w-[580px] mb-6 leading-[1.6] font-sans" data-id="element-144">
          Audios de frecuencias cerebrales + una guía diaria de 30 días diseñada
          para resetear tu sistema nervioso — para que dejes de sobrevivir y
          empieces a vivir.
        </p>

        <a href="#pricing" className="inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-hover text-dark font-bold uppercase font-serif text-base py-[18px] px-9 rounded-md transition-colors shadow-[0_4px_20px_rgba(201,168,76,0.3)] hover:shadow-[0_4px_24px_rgba(201,168,76,0.4)] w-full md:w-auto" data-id="element-145">
          <span data-id="element-146">
            SÍ, ESTOY LISTO PARA
            <br data-id="element-147" />
            MI RESET
          </span>
          <ArrowRightIcon className="w-5 h-5" data-id="element-148" />
        </a>
      </div>
    </section>;
}